import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { UnsavedModalComponent } from 'src/app/pages/player/player-detail/unsaved-modal/unsaved-modal.component';

export interface CanComponentDeactivateContent {
  getForm: () => FormGroup;
  saveChangesContent: () => Observable<boolean>;
  isEditable: boolean | string;
  params: string;
}

export const unsavedContentGuard: CanDeactivateFn<
  CanComponentDeactivateContent
> = (component, currentRoute, currentState, nextState) => {
  const modalService = inject(NgbModal);
  const form = component.getForm();
  const isEditable = component.isEditable;
  const mode = component.params

  // ✅ WHERE USER IS GOING
  const nextUrl = nextState?.url;


  if ((form.dirty && isEditable) || (form.dirty && (!mode || mode != 'edit'))) {
    const modalRef = modalService.open(UnsavedModalComponent, {
      centered: true,
      backdrop: 'static',
    });

    modalRef.componentInstance.isValidForm = form.valid;
    modalRef.componentInstance.nextUrl = nextUrl; // optional

    return new Observable<boolean>((observer) => {
      modalRef.result.then(
        (result) => {
          if (result === 'yes') {
            component.saveChangesContent().subscribe({
              next: (saveSuccessful) => {
                observer.next(saveSuccessful);
                observer.complete();
              },
              error: () => {
                observer.next(false);
                observer.complete();
              },
            });
          } else if (result === 'no') {
            setTimeout(() => {
              observer.next(true);
              observer.complete();
            }, 1000); // Discard changes
          } else {
            observer.next(false);
            observer.complete();
          }
        },
        () => {
          observer.next(false);
          observer.complete();
        },
      );
    });
  }

  return true;
};
